import { USE_MOCK } from '@/variables'

let apiClient = require('./mock').default
if (USE_MOCK === false) {
  apiClient = require('./server').default
}

export default apiClient
